import ViewReportLayout from './viewReportLayout.component';

export default ViewReportLayout;
